import { Component, OnDestroy, OnInit } from '@angular/core';
import { NbMediaBreakpointsService, NbMenuService, NbSidebarService, NbThemeService } from '@nebular/theme';

import { UserData } from '../../../@core/data/users';
import { LayoutService } from '../../../@core/utils';
import { map, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { Router } from '@angular/router';
import { AuthService } from '../../../_services/auth.service';
import { LocationStrategy } from '@angular/common';
import { WindowWidthService } from '../../../_services/windows.service';
import { ExcelService } from '../../../_services/excel.service';
import { HomeService } from '../../../pages/home/home.service';
import { RoleService } from '../../../_services/role.service';
@Component({
  selector: 'ngx-header',
  styleUrls: ['./header.component.scss'],
  templateUrl: './header.component.html',
})
export class HeaderComponent implements OnInit, OnDestroy {

  private destroy$: Subject<void> = new Subject<void>();
  userPictureOnly: boolean = false;

  excelLoading : boolean = false;

  user: any;

  themes = [
    {
      value: 'default',
      name: 'Light',
    },
    {
      value: 'dark',
      name: 'Dark',
    },
    {
      value: 'cosmic',
      name: 'Cosmic',
    },
    {
      value: 'corporate',
      name: 'Corporate',
    },
  ];

  currentTheme = 'default';

  userMenu = [ { title: 'Profile' }, { title: 'Log out' } ];
  innerWidth : number;
  constructor(private sidebarService: NbSidebarService,
              private themeService: NbThemeService,
              private userService: UserData,
              private layoutService: LayoutService,
              private breakpointService: NbMediaBreakpointsService,
              private router : Router,
              private authService : AuthService,
              private widthService : WindowWidthService,
              private excelService : ExcelService,
              private homeService : HomeService,
              private roleService : RoleService) {
  }

  ngOnInit() {

    this.innerWidth = this.widthService.windowWidth;
    this.currentTheme = this.themeService.currentTheme;

    this.userService.getUsers()
      .pipe(takeUntil(this.destroy$))
      .subscribe((users: any) => this.user = users.nick);

    const { xl } = this.breakpointService.getBreakpointsMap();
    this.themeService.onMediaQueryChange()
      .pipe(
        map(([, currentBreakpoint]) => currentBreakpoint.width < xl),
        takeUntil(this.destroy$),
      )
      .subscribe((isLessThanXl: boolean) => this.userPictureOnly = isLessThanXl);

    this.themeService.onThemeChange()
      .pipe(
        map(({ name }) => name),
        takeUntil(this.destroy$),
      )
      .subscribe(themeName => this.currentTheme = themeName);
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  changeTheme(themeName: string) {
    this.themeService.changeTheme(themeName);
  }

  toggleSidebar(): boolean {
    this.sidebarService.toggle(true, 'menu-sidebar');
    this.layoutService.changeLayoutSize();

    return false;
  }

  navigateHome() {
    this.router.navigateByUrl('/pages/home/overall')
    return false;
  }

  home(){
    if (this.router.url !== '/pages/home/dashboard'){
      this.router.navigateByUrl('/pages/home/dashboard')
    }
  }


  async downloadExcel(){
    this.excelLoading = true;
    const res = await this.homeService.getOverAllCourseReport();
    if (res.successful){
      this.excelService.exportToExcel(res.data,'course');
      this.excelLoading = false;
    }


  }


  async downloadProgramExcel(){
    this.excelLoading = true;
    const res = await this.homeService.getOverAllProgramReport();
    if (res.successful){
      this.excelService.exportToExcel(res.data,'course');
      this.excelLoading = false;
    }

  }


  goToCurriculum(){
    if (this.router.url !== '/pages/home/overall'){
      this.router.navigateByUrl('/pages/home/overall')
    }
  }



  compareBtn(){
    if (this.router.url !== '/pages/home/compare'){
      this.router.navigateByUrl('/pages/home/compare')
    }
  }
  collegeFormBtn(){
    console.log("college btn clicked")
    this.router.navigateByUrl('/pages/forms/college-form');
  }

  departmentFormBtn(){
    console.log("department btn clicked")
    this.router.navigateByUrl('/pages/forms/department-form');
  }

  curriculumFormBtn(){
    this.router.navigateByUrl('/pages/forms/curriculum-form');
  }


  courseFormBtn(){
    this.router.navigateByUrl('/pages/forms/course-form');
  }

  moduleFormBtn(){
    this.router.navigateByUrl('/pages/forms/module-form');
  }

  userBtn(){
    this.router.navigateByUrl('/pages/home/user-management');
  }
  clusterBtn(){
    this.router.navigateByUrl('/pages/forms/cluster');
  }

  importCourseBtn(){
    this.router.navigateByUrl('/pages/forms/import-course')
  }

  departmentReview(){
    this.router.navigateByUrl('/pages/report/department-report-form')
  }

  programReview(){
    this.router.navigateByUrl('/pages/report/program-report-form')
  }

  similarityReportBtn(){
    this.router.navigateByUrl('/pages/report/similarity-report')
  }

  excutiveSummaryBtn(){
    this.router.navigateByUrl('/pages/report/excutive-summary')
  }

  dashboardBtn(){
    this.router.navigateByUrl('/pages/report/report-dashboard')
  }


  logout(){
    this.authService.logout();
   this.router.navigateByUrl('/auth/login');
  }


  notAllowedToSee(){
    return this.authService.role !== 'Administrator';
  }

  allowedToSee(){
    return !this.roleService.isAllowedToAccess(['Administrator','Reviewer','Executive'])
  }




}
